const isInTeviWebview = () => {
    if (typeof window === 'undefined') return false
    const hasIOS = !!window.webkit?.messageHandlers?.TeviJSInterface
    const hasAndroid = !!window.TeviJSInterface
    return hasIOS || hasAndroid
}

const useTeviSdk = () => {
    const getUserInfo = () => {
        return new Promise((resolve, reject) => {
            if (!isInTeviWebview()) {
                resolve(null)
                return
            }

            window.TeviJS.getUserInfo({
                is_popup: true,
                app_id: import.meta.env.APP_ID || 'GHA06616',
            }, (data) => {
                resolve(data)
            }, (error) => {
                reject(error)
            })
        })
    }

    return {
        getUserInfo,
    }
}

export default useTeviSdk
